//分页操作

// 开启页面滚动监听
export function watchScroll(e, callback) {
  const scrollTop = e.target.scrollTop;
  // 可视区的高度
  const windowHeight = e.target.clientHeight;
  // 滚动条的总高度
  const scrollHeight = e.target.scrollHeight;
  if ((scrollTop + windowHeight) - scrollHeight > -1) {
    callback();
  }
}



// WEBPACK FOOTER //
// ./src/util/pagination.js